<template>
  <div id="footer">
    <div class="wrap">
      <div class="wrap-left">
        <img
          class="logo"
          src="@/assets/images/footer/logo2.svg"
          alt="星原统计"
        >
        <div class="address">
          <div class="title">关于我们</div>
          <div>地址：温州鹿城区车站大道777号 东游大厦805室</div>
          <div class="copyrights">版权所有：温州星原统计服务有限公司 ICP备案号：<a
              href="http://www.beian.miit.gov.cn"
              target="_blank"
            >浙ICP备17059754号</a></div>
        </div>
      </div>
      <div class="wrap-right">
        <div class="telephone">
          <div class="title">官方热线</div>
          <div class="phone-num">0577-88587692</div>
          <div class="week">周一至周日 9:00-18:00</div>
        </div>
        <div class="qr-code">
          <img
            class="qr-code-img"
            src="@/assets/images/footer/qrcode.jpg"
            alt="二维码"
          >
          <div class="desc">星原官方公众号</div>
        </div>
      </div>
    </div>
    <!-- <div class="copyrights">
      Copyright © {{ year }} ChingShen Co., Ltd. All rights reserved. <a
        href="http://www.beian.miit.gov.cn"
        target="_blank"
        nofollow
      >{{ icp }}</a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "FooterBar",
  computed: {
    year () {
      return new Date().getFullYear()
    },
    // icp () {
    //   let domain = document.domain
    //   let icp = ''
    //   if (domain.indexOf("chingshen.cn") >= 0) {
    //     icp = "浙ICP备18057471号-2"
    //   } else {
    //     icp = "浙ICP备19042061号-1"
    //   }
    //   return icp
    // }
  }
};
</script>

<style lang="less" scoped>
#footer {
  height: 220px;
  background-color: #282c36;

  .wrap {
    padding: 53px 30px 0;
    > div {
      line-height: 100%;
    }
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #fff;
    .title {
      margin-bottom: 27px;
      padding-bottom: 10px;
      border-bottom: 1px solid #64656d;
    }
    &-left {
      display: flex;
      .logo {
        margin-top: -24px;
        margin-right: 25px;
        width: 105px;
        height: 83px;
      }

      .copyrights {
        padding-top: 15px;
        font-size: 12px;
        text-align: center;
        opacity: 0.6;
        a {
          color: #fff;
          text-decoration: none;
          transition: color 0.1s;
          &:hover {
            color: #e6e6e6;
          }
        }
      }
    }
    &-right {
      display: flex;
      .title {
        margin-bottom: 18px;
      }
      .qr-code {
        margin-top: -10px;
        margin-left: 50px;
        text-align: center;
        .qr-code-img {
          width: 110px;
          height: 110px;
          margin-bottom: 10px;
        }
      }
      .phone-num {
        margin-bottom: 15px;
        font-size: 32px;
      }
      .week,
      .qr-code {
        font-size: 14px;
      }
      .week,
      .desc {
        opacity: 0.6;
      }
    }
  }
}
</style>